import './OrganizationsList.scss';
import '../../Admin.scss';
import '../../../../styles/_table.scss';
import { Link } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, LoadingPlaceholder } from '@trackman/web-shared-components';
import HeaderCreateButton from 'components/Admin/HeaderCreateButton/HeaderCreateButton';
import HeaderSearchbar from 'components/Admin/HeaderSearchbar/HeaderSearchbar';
import Paragraph from 'components/TextComps/Paragraph';
import { AdminPagesRelativeRoutes, DefaultRoutes } from 'Routes';
import useSetPageTitle from 'utilities/useSetPageTitle';
import SectionTitle from 'components/TextComps/SectionTitle';
import { useMemo, useState } from 'react';
import { AdminOrganizationsList } from 'types/admin/organizations';
import { useGetAdminOrganizationsList } from 'queryHooks/Admin/Organization/useGetAdminOrganizationsList';

export const OrganizationsList = () => {
  useSetPageTitle({ title: 'Organizations List' });

  const [filter, setFilter] = useState<string>('');
  const { data, isPending } = useGetAdminOrganizationsList();
  const filteredOrganizations: AdminOrganizationsList | undefined = useMemo(
    () => (!filter ? data : data?.filter((organization) => organization.name.toLowerCase().includes(filter.toLowerCase()))),
    [filter, data]
  );

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>Organizations List</h1>
      </div>
      <div className='admin-content-container'>
        {!isPending ? (
          filteredOrganizations && filteredOrganizations.length > 0 ? (
            <>
              <div className='admin-list-header'>
                <HeaderSearchbar searchValue={filter} onChange={(filter) => setFilter(filter)} placeholder='Search Organizations' />
                <HeaderCreateButton buttonTitle='New Organization' route={`${AdminPagesRelativeRoutes.OrganizationsEditor}`} />
              </div>

              <div className='tmu-table-wrapper'>
                <Table className='tmu-table admin-table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredOrganizations.map((row, index) => {
                      return <OrganizationsListRow key={index} id={row.id} name={row.name} disabled={row.disabled ?? false} />;
                    })}
                  </TableBody>
                </Table>
              </div>
            </>
          ) : (
            <div className='empty-state-card'>
              <div>
                <SectionTitle>
                  <>No Organizations added yet.</>
                </SectionTitle>
                <Paragraph>
                  <>No Organizations have been added yet.</>
                </Paragraph>
                <Paragraph>
                  <>Create one to get started</>
                </Paragraph>
              </div>
              <HeaderCreateButton buttonTitle='Create Organization' route={`${AdminPagesRelativeRoutes.OrganizationsEditor}`} />
            </div>
          )
        ) : (
          <LoadingPlaceholder />
        )}
      </div>
    </>
  );
};

type OrganizationsListRowProps = {
  id: string;
  name: string;
  disabled: boolean;
};
const OrganizationsListRow = ({ id, name, disabled }: OrganizationsListRowProps) => {
  return (
    <TableRow hover tabIndex={-1} key={id} className='organization-list-row'>
      <TableCell>
        <Link to={`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsEditor}/${id}`}>
          <div>{name}</div>
        </Link>
      </TableCell>
      <TableCell>
        <span className={disabled ? 'disabled-info' : ''}>{disabled ? 'Disabled' : 'Active'}</span>
      </TableCell>
    </TableRow>
  );
};
